import React from "react";
import { UserModel } from "../Models/User";
import { IUserContext } from "./IUserContext";

const UserContext = React.createContext<IUserContext>(undefined)
export const UserContextProvider = UserContext.Provider
export default UserContext

